import { is } from 'ramda';

const isNumber = is(Number);

export default isNumber;
